import { combineReducers } from 'redux';
import actionTypes from './actionTypes';
import { REDUCER_NAME } from './constants';
import { REDUCER_NAME as SHIPMENT_ESCALATION_REDUCER_NAME } from './shipmentEscalation/constants';
import { REDUCER_NAME as REASSIGNMENTS_REDUCER_NAME } from './reassignment/constants';
import shipmentEscalationReducer from './shipmentEscalation/reducer';
import reassignmentsReducer from './reassignment/reducer';

const initialState = {
  data: {
    delayedShipments: {
      value: 0,
      dataset: [],
    },
    deliveredShipments: {
      value: 0,
      dataset: [],
    },
    averageDurationTime: {
      value: 0,
      dataset: [],
    },
    exceptions: {
      value: 0,
      dataset: [],
    },
    driverRejectedShipments: {
      value: 0,
    },
    inRoute: {
      value: 0,
    },
    scheduled: {
      value: 0,
    },
    waitingDriverConfirmation: {
      value: 0,
    },
    driverCancelledShipments: {
      value: 0,
    },
    shipperCancelledShipments: {
      value: 0,
    },
    loading: {
      value: 0,
    },
    unloading: {
      value: 0,
    },
    delivered: {
      value: 0,
    },
    driverDispatched: {
      value: 0,
    },
  },
  isFetching: true,
  isFetched: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        data: initialState.data,
      };
    case actionTypes.FETCHED: {
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        data: action.payload.data,
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: reducer,
  [SHIPMENT_ESCALATION_REDUCER_NAME]: shipmentEscalationReducer,
  [REASSIGNMENTS_REDUCER_NAME]: reassignmentsReducer,
});
